interface LOWindow extends Window {
  __INITIAL_STATE__: any;
}

const win: LOWindow =
  typeof window !== 'undefined' ? window : ((global || {}) as any).window;

export { win as window };
